import { useTranslation } from '../../i18n/LocaleContext';

export default function DepositSuccessModal({ open, message, onClose }) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <div className="trade-modal trade-modal--center">
      <button
        type="button"
        className="trade-modal__backdrop"
        aria-label={t('common.close')}
        onClick={onClose}
      />
      <div className="trade-modal__panel trade-modal__panel--compact">
        <header className="trade-modal__header">
          <h2>{t('common.hint')}</h2>
          <button
            type="button"
            className="trade-modal__close"
            aria-label={t('common.close')}
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <div className="trade-success">
          <div className="trade-success__icon" aria-hidden>
            ✓
          </div>
          <p>{message || t('deposit.offlineSubmitSuccess')}</p>
          <button type="button" className="trade-modal__confirm is-ready" onClick={onClose}>
            {t('deposit.gotIt')}
          </button>
        </div>
      </div>
    </div>
  );
}
